module.exports = __webpack_public_path__ + "img/kia-New.c005e47b.png";